export const LAYERS = ['brand', 'region', 'base'] as const
export type LayerName = typeof LAYERS[number]

function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1)
}

export function getCollectionName(folder: string, layer: LayerName): string {
    const baseName = folder
        .split('/')
        .map((part, index) => {
            const camelPart = part.replace(/-([a-z])/g, (_, char) => char.toUpperCase())
            return index === 0 ? camelPart : capitalize(camelPart)
        })
        .join('')

    return `${baseName}${capitalize(layer)}`
}

export function getCollectionNames(folder: string): string[] {
    return LAYERS.map(layer => getCollectionName(folder, layer))
}
